import BrandMentionsAnalysisDashboard, {
  WIDGET_IDS,
} from "~/ui-rtk/components/features/dashboards/BrandMentionsAnalysisDashboard/BrandMentionsAnalysisDashboard"
import useConnect from "./connect"
import WithLoader from "~/ui-rtk/components/layout/WithLoader/WithLoader"
import useReconnectSourcesBanner from "~/ui-rtk/hooks/reconnect-sources-banner"
import { useEffect } from "react"
import ReconnectBanner from "~/ui-rtk/components/layout/ReconnectBanner/ReconnectBanner"
import useRequiredSourcesByWidgetIds from "~/ui-rtk/hooks/required-sources"

export default function MentionsAnalysis() {
  const { content, isLoading } = useConnect()

  const requiredSources = useRequiredSourcesByWidgetIds(WIDGET_IDS)

  const { connectorsToReconnect, setRequiredSources } =
    useReconnectSourcesBanner()

  useEffect(() => {
    setRequiredSources(requiredSources)
  }, [requiredSources])

  return (
    <WithLoader isLoading={isLoading}>
      <ReconnectBanner connectors={connectorsToReconnect} />
      <BrandMentionsAnalysisDashboard
        slug={content.slug}
        title={content.title}
        parent={content.parent}
        props={{
          commonGranularityPicker: true,
        }}
      />
    </WithLoader>
  )
}
